import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const RemoveHierarchyModal = ({
  isDeleteHierarchy,
  toggleDeleteHierarchy,
  onDeleteHierarchy,
  onClickDeleteEvent,
  eventId,
}) => {
  return (
    <>
      <Modal
        className={`modal-delete-event-hierarchy modal-md`}
        isOpen={isDeleteHierarchy}
        toggle={toggleDeleteHierarchy}
      >
        <ModalHeader>
          <div>
            Would you like to remove this event across the entire program
            hierarchy?
          </div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Button
            outline
            className="btn btn-primary btn-sm"
            onClick={() => {
              if (window.confirm("Are you sure to delete this Event?")) {
                onClickDeleteEvent(null, eventId);
              }
            }}
            color="#ffffff"
          >
            No, only remove from this program
          </Button>
          <Button
            outline
            className="btn btn-primary btn-sm"
            onClick={onDeleteHierarchy}
            color="#ffffff"
            style={{ float: "left" }}
          >
            Yes, remove from Hierarchy
          </Button>
          <Button
            outline
            color="primary"
            className="btn btn-sm"
            onClick={toggleDeleteHierarchy}
            style={{ float: "right" }}
          >
            Cancel
          </Button>
        </ModalBody>
      </Modal>
    </>
  );
};

export default RemoveHierarchyModal;
